//
// Copyright (c) 2011-2017 by Curalate, Inc.
//
import _ from 'underscore';

import SUMMARY_STATS_ACTIONS from '@instagram-account/instagram-account-constants/instagram-account-summary-stats-constants';
import { SummaryReferralsValue } from '@instagram-account/instagram-account-summary-referrals/components/instagramSummaryReferralsConstants';
import { SUMMARY_TREND_VALUES } from '@instagram-account/instagram-account-summary-trends/instagram-account-summary-trends-values';
import { InstagramAccountSummaryStatsModel } from '@instagram-account/reducers/instagram-account-summary-stats-model';

const initialState: InstagramAccountSummaryStatsModel = {
  summaryTrendGraphSelectedValue: SUMMARY_TREND_VALUES.CHANGE_IN_FOLLOWERS,
  summaryReferralsGraphSelectedValue: SummaryReferralsValue.Traffic,
};

export default function InstagramAccountSummaryStatsReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case SUMMARY_STATS_ACTIONS.CHANGE_SUMMARY_TREND_GRAPH_SELECTED_VALUE:
      return _.extend({}, state, {
        summaryTrendGraphSelectedValue:
          action.payload.summaryTrendGraphSelectedValue,
      });
    case SUMMARY_STATS_ACTIONS.CHANGE_SUMMARY_REFERRAL_GRAPH_SELECTED_VALUE:
      return _.extend({}, state, {
        summaryReferralsGraphSelectedValue:
          action.payload.summaryReferralsGraphSelectedValue,
      });
    default:
      return state;
  }
}
